import React, { FC, useCallback, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import debounce from 'lodash.debounce';
import { markAsPaid } from '@pharmaplan/common';
import Checkbox from '../../common/Checkbox';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import strings from '../../../localization';

interface IMarkAsPaid {
  bookingId: string;
  initState: boolean;
  customFunc: (id: string) => void;
  isAutoSyncRecord?: boolean;
}

const MarkAsPaid: FC<IMarkAsPaid> = ({
  bookingId,
  initState,
  customFunc,
  isAutoSyncRecord,
}) => {
  const dispatch = useAppDispatch();

  const [isPaid, setIsPaid] = useState(initState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleMarkAsPaid = useCallback(
    debounce(
      () => {
        customFunc(bookingId);
        setIsPaid((prevState) => {
          const newState = !prevState;

          if (newState) {
            dispatch(markAsPaid({ bookingId, paid: true, isAutoSyncRecord }));
          } else {
            dispatch(markAsPaid({ bookingId, paid: false, isAutoSyncRecord }));
          }
          return newState;
        });
      },
      300,
      { leading: true, trailing: false },
    ),
    [bookingId, customFunc],
  ); // 300ms debounce delay

  return (
    <Tooltip title={strings.markAsPaid}>
      <Box component="div">
        <Checkbox checked={isPaid} onChange={handleMarkAsPaid} />
      </Box>
    </Tooltip>
  );
};

export default MarkAsPaid;
